import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@glu/theming';
import { Drawer } from '@glu/drawer-react';

import styles from './Branding.styles';

import Toggle from '../Toggle/Toggle';
import Parts from '../Parts/Parts';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';

const Branding = ({
  classes, editableParts
}) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  return (
    <>
      <Toggle
        className={classnames(classes.toggle, { openDrawer })}
        onClick={() => setOpenDrawer(d => !d)}
      />
      <Drawer anchorTo="right" open={openDrawer} className={classes.root}>
        <div className={classes.drawerWrap}>
          <Header close={() => setOpenDrawer(false)} />
          <div className={`${classes.body} branding-body`}>
            <Parts parts={editableParts} />
          </div>
          <Footer parts={editableParts} />
        </div>
      </Drawer>
    </>
  );
};

Branding.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  /** the parts of the theme that are editable */
  editableParts: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    labelText: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.shape({}))
  })).isRequired
};

export default withStyles(styles)(Branding);
